import React, { Component } from "react";
import { observer } from "mobx-react";

import { Uuid } from "@formant/core/model/Uuid";
import { HStack } from "@formant/ui/component/common/HStack";
import { Icon } from "@formant/ui/component/common/Icon";

import {
    appStore,
    deviceDetailsStore,
    operateStore,
    organizationStore,
} from "../../../stores";
import { OutageBanner } from "../../OutageBanner";
import { DeviceButton } from "./DeviceButton";
import * as styles from "./index.scss";

export interface INavigationProps {
    id: Uuid;
}

@observer
export class Navigation extends Component<INavigationProps> {
    public render() {
        const { id } = this.props;
        const device = deviceDetailsStore.get(id);
        const { share } = operateStore;

        if (share) {
            return false;
        }

        return (
            <div className={styles.container}>
                {organizationStore.outageBannerEnabled() && <OutageBanner />}
                <HStack vAlign="center" className={styles.navigation}>
                    <div onClick={this.onMenu} className={styles.menu}>
                        <Icon name="menu" />
                    </div>
                    {device && <DeviceButton device={device} />}
                </HStack>
            </div>
        );
    }

    private onMenu = () => {
        appStore.sidebarIsOpen = true;
    };
}
